import messages from "@smartmixin/i18n/dist/translations/es.json";

export default messages;
